export default __webpack_public_path__ + "static/media/5.8509df60.jpg";